<!-- Search and NEW -->
<div class="flexie-auto-grid p-b-20">
  <div>
    <h3>Search</h3>
    <!-- <app-ui-search [searchables]="['Customer Name','Policy Number','Customer Email','Customer Phone','Customer First Name']" (searchEmit)="searchedFor($event)"></app-ui-search> -->
  </div>
  <div class="text-a-right">

    <!-- New Dropdown approach -->
    <!-- <nz-dropdown-button [nzType]="'primary'" (nzClick)="modNewServiceReq=true">
      <i nz-icon nzType="plus" nzTheme="outline"></i> New Service Request
      <ul nz-menu>
        <li nz-menu-item (click)="modNewServiceReq=true">
          By Customer
        </li>
        <li nz-menu-item (click)="modNewServiceReq=true">
          By Policy
        </li>
      </ul>
    </nz-dropdown-button> -->

    <!-- OLD BUTTON
    <button nz-button [nzType]="'primary'" (click)="newIntimation()"><i nz-icon nzType="plus" nzTheme="outline"></i> New Intimation</button>
    -->

  </div>
</div>

<h3 class="heading"><i class="anticon anticon-user"></i> Customers</h3>

<!-- Data -->
<nz-table [nzData]="[1]" [nzScroll]="{ x: '1100px' }" [nzLoading]="isLoading">
  <thead>
    <!-- HEADINGS -->
    <tr>
      <th *ngFor="let i of tableData.keys">{{i.name}}</th>
    </tr>
  </thead>
  <tbody>
    <!-- DATA -->
    <tr *ngFor="let i of tableData.values">
      <td><a (click)="newSR('details')">{{i.custName}}</a></td>
      <td>{{i.custEmail}}</td>
      <td>{{i.custPhone}}</td>
      <td>
        <span class="d-b" *ngFor="let p of i.policy; let dex=index">
          <a (click)="newSR('details')" >{{p}}</a>
          <span *ngIf="dex<(i.policy.length-1)">, </span>
        </span>
      </td>
      <td>{{i.policyCommencement}}</td>
    </tr>
  </tbody>
</nz-table>

<!-- Search Policy or Customer -->
<nz-modal nzMaskClosable="false" [(nzVisible)]="modNewServiceReq"
          nzTitle="Create Service Request"
          (nzOnCancel)="modNewServiceReq=false" (nzOnOk)="modNewServiceReq=false"
          nzClosable
          [nzFooter]="null"
          nzWidth="75%"
>
<div *ngIf="modNewServiceReq">
  <nz-steps [nzCurrent]="current">
    <nz-step nzTitle="Customer / Policy"></nz-step>
    <nz-step nzTitle="Service Request"></nz-step>
    <nz-step nzTitle="Status"></nz-step>
  </nz-steps>

  <div class="steps-content p-t-20">

    <!-- IMPORTANT: DEMO CODE --- PRODN MUST change logic current==0 current==1 etc to DYNAMIC one!! -->

    <div *ngIf="current==0">
      <div class="search-by-cust-or-policy">

        <app-ui-policy-search-add></app-ui-policy-search-add>

      </div>
    </div>

    <div *ngIf="current==1">
      <div>

        <!-- Request Type SELECTION -->
        <label for="srvcing" class="d-b p-t-b-5">
          Request type
          <nz-tag *ngIf="requestTypeSelected" [nzColor]="'#555'" class="point-e-0 d-i-b m-t-b-10">{{requestTypeSelected.type}}</nz-tag>
        </label>
        <nz-select nzShowSearch [(ngModel)]="requestTypeSelected" nzAllowClear nzPlaceHolder="Choose" id="srvcing" class="d-b w-100-pc" (ngModelChange)="loader()">
          <nz-option *ngFor="let t of requestTypes" [nzValue]="t" [nzLabel]="t.name + ' (' + t.type + ')'"></nz-option>
        </nz-select>

        <div class="srvc-form-container p-t-20">
          <app-servicing-request-form *ngIf="!isLoading" [formType]="requestTypeSelected.formType"></app-servicing-request-form>
        </div>

      </div>
    </div>

    <div *ngIf="current==2">
      <div class="zero-ui">
        <i nz-icon nzType="check-circle" nzTheme="outline" style="color:#84AC2F"></i>
        <h2>#SR017617634</h2>
        <p>Service Request created & task has been auto-assigned</p>
      </div>
    </div>

  </div>

  <div class="flex flex-horiz-space-bw b-t-1 p-t-20 m-t-20">
    <button nz-button nzType="danger" (click)="modNewServiceReq=false">Cancel</button>
    <div class="steps-action">
      <button nz-button nzType="default" (click)="pre()" *ngIf="current > 0">
        <span>Previous</span>
      </button>
      <nz-divider nzType="vertical"></nz-divider>
      <button nz-button nzType="primary" (click)="next()" *ngIf="current < 2">
        <span>Next</span>
      </button>
      <button nz-button nzType="primary" (click)="done()" *ngIf="current === 2">
        <span>Done</span>
      </button>
    </div>
  </div>

</div>
</nz-modal>
